import { FormNames, IFormDefinition } from 'models/Form/FormModels'
import { AppLinks } from 'enviroment/AppLinks'
import { mObywatelExtendedInfoFields } from './MObywatelExtendedInfoFields'

export const mObywatelExtendedInfoForm: IFormDefinition = {
   name: FormNames.MObywatelExtendedInfoForm,
   fields: mObywatelExtendedInfoFields,
   labelTextContentPath: "mObywatelExtendedInfoFormPage.label",
   urlPath: AppLinks.mObywatelExtendedInfoForm,
   nextStepUrlPath: AppLinks.waiting,
   canStepBack: false,
   subbmitButtonTextContentPath: "mObywatelExtendedInfoFormPage.subbmitButtonText"
}